import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";

import { FocusTrap } from "focus-trap-react";

import { ModalProps } from "./types";

import { useClickAway } from "@/hooks/useClickAway";
import { tw } from "@/utils";

export default function Modal(props: ModalProps) {
  const portalElement = useMemo(
    () => document.getElementById("portal") as HTMLElement,
    []
  );
  const { onClose, children, preventClose = false } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const [enableFocusTrap, setEnableFocusTrap] = useState(false); // 초기에는 비활성화

  useClickAway(contentRef, !preventClose ? onClose : () => {});

  useEffect(() => {
    document.documentElement.classList.add("overflow-hidden");
    document.documentElement.classList.add("fixed");

    // 일정 시간 후 FocusTrap 활성화
    const timeout = setTimeout(() => setEnableFocusTrap(true), 200);

    return () => {
      clearTimeout(timeout);
      document.documentElement.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("fixed");
    };
  }, []);

  return createPortal(
    // <FocusTrap
    //   active={enableFocusTrap}
    //   focusTrapOptions={{ initialFocus: false }}
    // >
    <div
      className={tw(
        "fixed left-0 top-0 z-[1000] flex h-full w-full overflow-auto bg-gray-g300/50 p-[20px]"
      )}
      // style={{ height: "calc(var(--vh) * 100)" }}
      onKeyDown={(e) => {
        if (e.key === "Escape") onClose();
      }}
    >
      <div className="m-auto max-w-full max-h-full" ref={contentRef}>
        {children}
      </div>
    </div>,
    portalElement
  );
}
